import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { Box, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField, Tooltip, Typography } from "@mui/material";

import { useCookies } from "react-cookie";
import LoadingButton from "@mui/lab/LoadingButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ValidateEmail, ValidatePwd } from "../Common/helpers";

import { AppContext } from "../../AppContext";
export default function CommonDetails({ mode, state, setState, setBackDrop }) {
	const [complete, setComplete] = useState(false);
	const app = useContext(AppContext);
	const [cookies, setCookie, removeCookie] = useCookies(["_bkeys"]);
	const handleClose = () => {
		onClose();
	};

	const [formData, setFormData] = useState(state);
	const [loadingState, setLoadingState] = useState(false);
	const [devMode, setDevMode] = useState(window.location.href.startsWith("http://localhost"));
	const handleChange = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		console.log("ValidatePwd(formData.pwd1)", ValidatePwd(formData.pwd1))
		if (
			formData.firstname !== "" &&
			formData.lastname !== "" &&
			["1", "2"].includes(formData.gender) &&
			ValidateEmail(formData.email) &&
			ValidatePwd(formData.pwd1).res &&
			formData.pwd1 === formData.pwd2
		) {
			setComplete(true);
		} else {
			setComplete(false);
		}
	}, [formData]);
	const manageSubmit = () => {
		//	setBackDrop(true);
		setLoadingState(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				gender: formData.gender,
				lname: formData.lastname,
				fname: formData.firstname,
				email: formData.email,
				pwd: formData.pwd1,
			}),
		};
		const url = mode === "A" ? "am" : mode === "V" ? "vn" : "pr";
		fetch("/anon/signup/" + url, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setCookie("_bkeys", res.session_token, { path: "/" });
						setCookie("_bkuser", res.name, { path: "/" });
						setState({ ...state, step: 1 });
						location.replace(mode === "A" ? "/devenir-ambassadeur/1" : mode === "V" ? "/devenir-vendeur/1" : "/devenir-acquereur/1");
						break;

					case "err":
						app.refSnack.current.handleChangeState({ o: true, m: "Erreur: " + res.reason, s: "error" });
						setBackDrop(false);
						setLoadingState(false);
						break;
					default:
						break;
				}
			});
	};

	////////////
	const [values, setValues] = useState({
		showPassword: false,
	});
	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	////////

	return (
		<div style="padding-right: 10px; padding-left: 10px;">
			<Typography variant="caption">Tous les champs sont obligatoires</Typography>
			<div>
				{" "}
				<FormControl component="fieldset">
					<RadioGroup row aria-label="gender" name="gender" value={formData.gender} onChange={handleChange}>
						<FormControlLabel value={"1"} control={<Radio color="primary" />} label="Mme" />
						<FormControlLabel value={"2"} control={<Radio color="primary" />} label="M" />
					</RadioGroup>
				</FormControl>
			</div>
			<div>
				<TextField
					id="firstname"
					name="firstname"
					variant="outlined"
					style={{
						marginLeft: 0,
						marginRight: 10,
					}}
					placeholder="Prénom"
					fullWidth
					margin="dense"
					value={formData.firstname}
					onChange={handleChange}

					size="small"
				/>
			</div>
			<div>
				<TextField
					id="lastname"
					name="lastname"
					variant="outlined"
					style={{
						marginLeft: 0,
						marginRight: 10,
					}}
					placeholder="Nom"
					fullWidth
					margin="dense"
					value={formData.lastname}
					onChange={handleChange}


					size="small"
				/>
			</div>

			<div>
				<TextField
					id="email"
					name="email"
					variant="outlined"
					style={{
						marginLeft: 0,
						marginRight: 10,
					}}
					placeholder="Email"
					fullWidth
					margin="dense"
					value={formData.email}
					onChange={handleChange}

					size="small"
				/>
			</div>
			{formData.email !== undefined && !ValidateEmail(formData.email) && (
				<div>
					<Typography variant="caption" color="primary">
						L'email n'est pas valide
					</Typography>
				</div>
			)}
			<div>
				<Box display="flex" alignItems="center" justifyContent="space-between" p={1} m={1} style="padding: 0px; margin: 0px;">
					<Box p={1} style="padding: 0px; margin: 0px; flex-grow: 1;">
						<TextField
							id="pwd1"
							name="pwd1"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Mon mot de passe (6 caractères min)"
							fullWidth
							margin="dense"
							value={formData.pwd1}
							onChange={handleChange}
							type={values.showPassword ? "text" : "password"}

							size="small"
						/>
					</Box>
					<Box p={1}>
						<Tooltip title={values.showPassword ? "Masquer le mot de passe" : "Voir le mot de passe"} aria-label="add">
							<IconButton aria-label="mot de passe " onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
								{values.showPassword ? <Visibility /> : <VisibilityOff />}
							</IconButton>
						</Tooltip>
					</Box>
				</Box>
			</div>
			<div>
				<Typography variant="caption">
					Le mot de passe doit faire 6 caractères minimum et contenir au moins une majuscule, un chiffre et un caractère{" "}
					<span onClick={() => setFormData({ ...formData, pwd1: "Aqwaqw&1", pwd2: "Aqwaqw&1" })}>spécial</span>
				</Typography>
			</div>
			<div>
				<TextField
					id="pwd2"
					name="pwd2"
					variant="outlined"
					style={{
						marginLeft: 0,
						marginRight: 10,
					}}
					placeholder="Confirmation de mon mot de passe"
					fullWidth
					margin="dense"
					value={formData.pwd2}
					onChange={handleChange}
					type={values.showPassword ? "text" : "password"}

					size="small"
				/>
			</div>
			{formData.pwd1 !== undefined && !ValidatePwd(formData.pwd1).res &&

				ValidatePwd(formData.pwd1).hints.map((hint) => {
					return (
						<div>
							<Typography variant="caption" color="primary">
								{hint}
							</Typography>
						</div>)
				}
				)
			}
			{formData.pwd1 !== "" && formData.pwd2 !== undefined && formData.pwd1 !== formData.pwd2 && (
				<div>
					<Typography variant="caption" color="primary">
						Le mot de passe et sa confirmation ne sont pas identiques
					</Typography>
				</div>
			)}
			<div>
				<Box display="flex" alignItems="center" justifyContent="center" p={1} m={1} style="padding: 0px; margin: 0px;">
					<Box p={1} style="padding: 0px; margin: 0px; ">
						{/*<NavPrimaryButtonMk2 cb={manageSubmit} disabled={!complete} txt="S'inscrire" />*/}
						<LoadingButton loading={loadingState} onClick={manageSubmit} disabled={!complete} variant="contained">
							S'inscrire
						</LoadingButton>
					</Box>
				</Box>
			</div>
		</div>
	);
}
